import {CommonMessages} from '../common.messages';

export const PanelClientsAddMessages = {
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while communication with the server. Unable to get available countries'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Invalid data for countries.'
    },
    GetConfidentialClientsFailed: {
        key: 'GetConfidentialClientsFailed',
        message: 'Error while communication with the server. Unable to get available portals.'
    },
    GetConfidentialClientsInvalidData: {
        key: 'GetConfidentialClientsInvalidData',
        message: 'Invalid data for portals.'
    },
    UserSearchFailed: {
        key: 'UserSearchFailed',
        message: 'Error while processing user registration request. Unable to try to match user details.'
    },
    UserExists: {
        key: 'UserExists',
        message: 'Already have registered user with the entered email address.'
    },
    UserCreationFailed: {
        key: 'UserCreationFailed',
        message: 'Error while processing user registration request. Unable to register user.'
    },
    PhoneCreationFailed: {
        key: 'PhoneCreationFailed',
        message: 'Error while processing phone registration request. Unable to register phone.'
    },
    ...CommonMessages
};
